import {
    ContactIcon,
    PollIcon,
  } from "../../../../../svg";
import { MapPin } from "lucide-react";
import DocumentAttachment from "./DocumentAttachment";
import PhotoAttachment from "./PhotoAttachment";
import CameraAttachment from "./CameraAttachment";
import StickerAttachment from "./StickerAttachment";
//   import DocumentAttachment from "./DocumentAttachment";
//   import PhotoAttachment from "./PhotoAttachment";
  
  export default function Menu({ onContact, onLocation, onInteractive }) {
    const baseBtn = "w-10 h-10 flex items-center justify-center rounded-full";
    return (
      <ul className="absolute bottom-14 openEmojiAnimation">
        <li>
          <button
            type="button"
            className={baseBtn}
            onClick={() => onInteractive?.()}
            title="رسالة تفاعلية"
            aria-label="رسالة تفاعلية"
          >
            <PollIcon />
          </button>
        </li>
        <li>
          <button
            type="button"
            className={`${baseBtn} bg-[#0EABF4]`}
            onClick={() => onContact?.()}
            title="إرسال جهة اتصال"
            aria-label="إرسال جهة اتصال"
          >
            <ContactIcon />
          </button>
        </li>
        <DocumentAttachment />
        <CameraAttachment />
        <StickerAttachment />
        <PhotoAttachment />
        <li>
          <button
            type="button"
            className={`${baseBtn} bg-[#0EABF4]`}
            onClick={() => onLocation?.()}
            title="إرسال موقع"
            aria-label="إرسال موقع"
          >
            <MapPin className="w-5 h-5 text-white" />
          </button>
        </li>
      </ul>
    );
  }